import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecordFormPage } from './record-form.page';

const routes: Routes = [
  {
    path: '',
    component: RecordFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecordFormPageRoutingModule {}
